import TaskListPage from './list/'
import TaskAddPage from './add/'
import TaskViewPage from './view/'

export default {
  TaskListPage,
  TaskViewPage,
  TaskAddPage
}
